import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { useIntl } from "react-intl";
const options = {
  type: "line",
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: "rgba(50, 50, 50, 0.8)",
      bodyFont: { size: 14 },
    },
  },
  layout: {
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },

  scales: {
    x: {
      position: "bottom", // Align x-axis labels to the top
      ticks: {
        color: "black",
        font: { size: 12, family: "Arial" },
      },
      grid: {
        color: "rgba(0, 0, 0, 0)",
      },
    },
    y: {
      position: "right", // Align y-axis labels to the right
      ticks: {
        color: "black",
        font: { size: 12, family: "Arial" },
      },
      grid: {
        color: "rgba(0, 0, 0, 0)",
      },
    },
  },
  indexAxis: "x",
  maintainAspectRatio: false, // Disable maintaining aspect ratio
  aspectRatio: 1, // Set the aspect ratio to control the height
  plugins: {
    tooltip: {
      mode: "index",
      intersect: false,
    },
  },
  parsing: {
    xAxisKey: "month",
    yAxisKey: "value",
  },
};
const x1 = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

const MostBookedServices = ({ data }) => {
  const intl = useIntl();
  const { locale } = useIntl();

  const labels = [
    intl.formatMessage({
      id: "january",
    }),
    intl.formatMessage({
      id: "february",
    }),
    intl.formatMessage({
      id: "march",
    }),
    intl.formatMessage({
      id: "april",
    }),
    intl.formatMessage({
      id: "may",
    }),
    intl.formatMessage({
      id: "june",
    }),
    intl.formatMessage({
      id: "july",
    }),
    intl.formatMessage({
      id: "august",
    }),
    intl.formatMessage({
      id: "september",
    }),
    intl.formatMessage({
      id: "october",
    }),
    intl.formatMessage({
      id: "november",
    }),
    intl.formatMessage({
      id: "december",
    }),
  ];
  const reversedLabels = labels.slice().reverse();
  const colorsGrad = (id) => {
    const handleGradientBackground = ({ chart: { ctx } }) => {
      const gradient = ctx.createLinearGradient(0, 0, 0, 300);

      switch (id) {
        case 1:
          // Purple to soft lilac gradient
          gradient.addColorStop(0, "rgba(149, 164, 252, 0.29)"); // Black
          gradient.addColorStop(1, "rgba(149, 164, 252, 0.11)"); // White
          break;
        case 2:
          // Cerulean to light cerulean gradient
          gradient.addColorStop(0, "rgba(0, 123, 167, 0.29)"); // Darker cerulean
          gradient.addColorStop(1, "rgba(0, 123, 167, 0.11)"); // Lighter cerulean
          break;
        case 3:
          // Coral to light coral gradient
          gradient.addColorStop(0, "rgba(255, 99, 71, 0.29)"); // Darker coral
          gradient.addColorStop(1, "rgba(255, 99, 71, 0.11)"); // Lighter coral
          break;
        case 4:
          // Teal to light teal gradient
          gradient.addColorStop(0, "rgba(56, 239, 125, 0.29)"); // Darker teal
          gradient.addColorStop(1, "rgba(56, 239, 125, 0.11)"); // Lighter teal
          break;
        default:
          // Default soft grey gradient
          gradient.addColorStop(0, "rgba(189, 189, 189, 0.29)"); // Dark grey
          gradient.addColorStop(1, "rgba(189, 189, 189, 0.11)"); // Light grey
      }

      return gradient;
    };
    return handleGradientBackground;
  };
  const processItems = (data, x, colors) => {
    const tempStorage = {};

    x?.forEach((e) => {
      // Check if data for the month exists and has length
      if (!data[e] || data[e].length === 0) return;

      data[e].forEach((item, id) => {
        const monthIndex = parseInt(e, 10) - 1;
        if (!tempStorage[item.id]) {
          // Initialize new item structure if not already present
          tempStorage[item.id] = {
            label: item.name,
            id: item.id,
            borderColor: "rgba(149, 164, 252)",
            data: new Array(12).fill(0),
            backgroundColor: colors(id), // Ensure this is correctly handled for gradients or static colors
            fill: true,
            borderWidth: 1,
          };
        }

        // Safely add appointments_count, with a fallback to 0 if undefined
        tempStorage[item.id].data[monthIndex] += item.appointments_count || 0;
      });
    });

    // After populating and summing up the data, reverse the data arrays for each item
    locale === "ar" &&
      Object.values(tempStorage).forEach((item) => {
        item.data.reverse();
      });

    return Object.values(tempStorage);
  };
  const datasets = processItems(data, x1, colorsGrad);
  const data1 = {
    labels: locale === "ar" ? reversedLabels : reversedLabels.reverse(),
    datasets,
  };

  return (
    <div style={{ height: "18rem" }} className="">
      <Line id={100} options={options} data={data1} />
    </div>
  );
};

export default MostBookedServices;
